import { isNavLinkActive, navLinkProps } from "@core/layouts/utils";
import { computed, ref } from "@vue/composition-api";
import { InboxModulePathType } from "@saysimple-platform/dtos";
import useUnreadChats from "@/composables/v2.1/useUnreadChats";
import numberLimiter from "@/utils/numberLimiter.util";

export default function useVerticalNavMenuLink(item) {
    const isActive = ref(false);

    const linkProps = navLinkProps(item);

    const updateIsActive = () => {
        isActive.value = isNavLinkActive(item);
    };

    const {
        totalFilteredUnreadMessagingChatsCount,
        totalFilteredUnreadEmailChatsCount,
        totalFilteredUnreadTeamChatsCount,
    } = useUnreadChats();
    const counter = computed(() => {
        if (item.route === InboxModulePathType.MESSAGING) {
            return numberLimiter(totalFilteredUnreadMessagingChatsCount.value, 3);
        }

        if (item.route === InboxModulePathType.EMAIL) {
            return numberLimiter(totalFilteredUnreadEmailChatsCount.value, 3);
        }

        // if (item.route === InboxModulePathType.TEAM) {
        if (item.route === "team-chat") {
            return numberLimiter(totalFilteredUnreadTeamChatsCount.value, 3);
        }
    });

    return {
        isActive,
        linkProps,
        updateIsActive,
        counter,
    };
}
